module.exports = __webpack_public_path__ + "static/media/alarm-clock.54e3f465.svg";